import { render, staticRenderFns } from "./PastAlertsTable.vue?vue&type=template&id=4c8c0f04"
import script from "./PastAlertsTable.vue?vue&type=script&lang=js"
export * from "./PastAlertsTable.vue?vue&type=script&lang=js"
import style0 from "./PastAlertsTable.vue?vue&type=style&index=0&id=4c8c0f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports